import styles from '../../../styles/footer.module.css';
import logo from "../../../images/igs_logo.png";
const Footer = () => {
    return ( 
        <div>
        <footer className={styles.footerwrapper}>
            <div className={styles.footercontent}>
                            <ul className={styles.links}>
                <div className={styles.navlinks}>
                <li><a href="/">Home</a></li>
                <li><a href="/blogs">News</a></li>
                <li><a href="/calender">Calender</a></li>
                </div>

            </ul>
                <p>© 2025 Inisa Grammar School. All rights reserved.</p>
              
            </div>
            <img className={styles.logo} src={logo}/>

            
        </footer>
          <p className={styles.developer}>Designed and Developed by <a href='https://richcodedev.iceiy.com' target='_blank'>RICHCODE</a></p>
        </div>
     );
}
 
export default Footer;
